export enum PermissionActions {
  View = 'view',
  Create = 'create',
  Remove = 'remove',
  Update = 'update',
  Download = 'download',
  Transfer = 'transfer',
}
